import React from "react"
import * as style from "./style.module.css"

const Component = ({ media, alt = "" }) => {
  return (
    <>
      {media.type === 1 ? (
        <img src={media.url} className={style.inner_media} alt={alt} />
      ) : (
        <video autoPlay loop muted className={style.inner_media}>
          <div>{media.url}</div>
          <source src={media.url} alt={alt} />
        </video>
      )}
    </>
  )
}

export default Component
